import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "section mb-rem5" }
const _hoisted_2 = { class: "section lg:text-center" }

import ArticleModalContent from '@/components/ArticleModalContent.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Ortopan',
  emits: ["close", "navigate"],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_a_info_panel = _resolveComponent("a-info-panel")!
  const _component_a_circular_image = _resolveComponent("a-circular-image")!

  return (_openBlock(), _createBlock(ArticleModalContent, {
    title: _ctx.$t('articles.ortopan.title'),
    cover: require('@/assets/covers/xray.jpg'),
    "close-button-dark": true,
    onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_info_panel, {
          icon: require('@/assets/png-icons/bulb.png'),
          class: "mb-rem2 narrow-text"
        }, {
          default: _withCtx(() => [
            _createElementVNode("b", null, _toDisplayString(_ctx.$t('articles.ortopan.infoPanelBold')), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('articles.ortopan.infoPanelBody')), 1)
          ]),
          _: 1
        }, 8, ["icon"]),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('articles.ortopan.intro')), 1),
        _cache[2] || (_cache[2] = _createElementVNode("hr", null, null, -1)),
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t('articles.ortopan.potekTitle')), 1),
        _createVNode(_component_a_circular_image, {
          image: require('@/assets/photos/xray-small.jpg'),
          class: "sm:-mt-rem5 sm:!ml-16"
        }, null, 8, ["image"]),
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(_ctx.$t('articles.ortopan.potekP1')) + " ", 1),
          _createElementVNode("b", null, _toDisplayString(_ctx.$t('articles.ortopan.potekRadiation')), 1)
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("hr", null, null, -1)),
        _createVNode(_component_a_circular_image, {
          image: require('@/assets/ortopan.jpg')
        }, null, 8, ["image"]),
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t('articles.ortopan.priporocilTitle')), 1),
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(_ctx.$t('articles.ortopan.priporocilP1')) + " ", 1),
          _createElementVNode("b", null, _toDisplayString(_ctx.$t('articles.ortopan.priporocilSafe')), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('articles.ortopan.priporocilP2')), 1)
        ])
      ]),
      _cache[4] || (_cache[4] = _createElementVNode("hr", null, null, -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(_ctx.$t('articles.ortopan.cenikPre')), 1),
          _createElementVNode("b", {
            class: "internal-link",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('navigate', 'cenik', 'rentgen')))
          }, _toDisplayString(_ctx.$t('articles.ortopan.cenikLinkText')), 1),
          _createTextVNode(_toDisplayString(_ctx.$t('articles.ortopan.cenikPost')), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "cover"]))
}
}

})